import React, { useState, useCallback, useEffect, useRef } from 'react'
import { PageProps } from 'gatsby' //, Link, graphql
import { useInterval } from 'react-use' //useWindowScroll

import cn from 'classnames'

import SEO from '~/components/seo'
import Kv from '~/components/top-kv'
import Slider from '~/components/slider'

import Question from '~/components/question'
import BorderButton from '~/components/button/border'

import { PageFooter, SiteFooter } from '~/components/footer'

import IntroWave from '~/assets/svg/intro-wave.svg'
import IntroQ from '~/assets/svg/intro-q-ao.svg'

import DeptIcon1 from '~/assets/svg/q-k1i.svg'
import DeptIcon2 from '~/assets/svg/q-k2i.svg'

import DeptIcon3 from '~/assets/svg/q-g1i.svg'
import DeptIcon4 from '~/assets/svg/q-g2i.svg'
import DeptIcon5 from '~/assets/svg/q-g3i.svg'

import EsFig from '~/assets/svg/k-hyo.svg'
import GeoFig from '~/assets/svg/g-hyo.svg'

import { kv, es, geo } from '~/data'

import s from './styles.module.scss'

// import status from '~/components/status'

const isIOS = /iP(hone|(o|a)d)/.test(
  typeof window !== `undefined` ? window.navigator.userAgent : ''
)

const useRequestAnimationFrame = (callback) => {
  const requestRef = useRef(0)
  const previousTimeRef = useRef(0)

  const animate = (time) => {
    if (previousTimeRef.current != 0) {
      const deltaTime = time - previousTimeRef.current
      callback(deltaTime)
    }
    previousTimeRef.current = time
    requestRef.current = requestAnimationFrame(animate)
  }

  useEffect(() => {
    if (!isIOS) requestRef.current = requestAnimationFrame(animate)
    return () => {
      if (!isIOS) cancelAnimationFrame(requestRef.current)
    }
  }, [])
}

type DataProps = {}

const Page: React.FC<PageProps<DataProps>> = ({}) => {
  // const { y } = useWindowScroll()

  const scrollY = useRef(0)
  const speed = useRef(0)
  const count = useRef(0)

  const [y, setY] = useState(0)
  const [offset, setOffset] = useState(
    typeof window !== `undefined`
      ? window.innerHeight / 2 - (window.innerWidth / 32) * 4
      : 0
  )

  // const onScroll = useCallback((e) => {
  //   setY(e.scroll.y)
  // }, [])
  const onResize = useCallback((e) => {
    setOffset(window.innerHeight / 2 - (window.innerWidth / 32) * 4)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      // if (status.locoScroll) status.locoScroll.off('scroll', onScroll)
    }
  }, [])

  // useEffect(() => {
  //   if (status.locoScroll) status.locoScroll.on('scroll', onScroll)
  // }, [status.locoScroll])

  const animate = () => {
    const target = window.pageYOffset < 50 ? 0 : offset

    speed.current += scrollY.current - window.pageYOffset
    speed.current += -speed.current * 0.2
    scrollY.current = window.pageYOffset

    setY(target + speed.current)
  }

  useInterval(
    () => {
      animate()
    },
    isIOS ? 1000 / 30 : null
  )

  useRequestAnimationFrame(() => {
    count.current++
    if (count.current % 2 !== 0) return
    count.current = 0
    animate()
  })

  return (
    <>
      <SEO />

      <div
        className={s.qwrap}
        style={{ transform: `translateY(${y}px)` }}
        // style={{ transform: `translateY(${y < 50 ? 0 : offset + y}px)` }}
      >
        <Question />
      </div>

      <div className={s.kv}>
        <Kv items={kv} />
        <h1>
          すべての疑問が、
          <br />
          学問になる。
        </h1>
        <p className={s.lead}>
          なぜ、この川はこんなに汚れているんだろう。なぜ、ここは空気が澄んでいるように感じるんだろう。なぜ、この産業は衰退しているんだろう。なぜ、この地域の人たちはこれほどまで心豊かに暮らしているんだろう。ふだん私たちが感じるふとした疑問の奥には、あらゆる自然環境や社会構造、国際関係、歴史、文化、都市構造、経済状況など、さまざまな事情が重なり合っています。立正大学地球環境科学部には、8つの分野にわたる教員が37名在籍。323の講義を用意して、あなたの学びを広く、深くサポートします。あなたの中にある好奇心から広がる世界は無限です。そうか、そういうことだったのか！と、点と点が線になる瞬間のよろこびの連続が、世界の不思議を解き明かし、環境や地域の問題を解決する大切な糧となっていきます。そしてあなたの4年間を、いや、これから先の人生を、きっと豊かにしてくれる原動力となっていくはずです。
        </p>

        <IntroQ
          className={s.bg1}
          // data-scroll data-scroll-speed="-0.5"
        />
        <IntroWave
          className={s.bg2}
          // data-scroll
          // data-scroll-speed="-0.5"
          // data-scroll-direction="horizontal"
        />
      </div>

      <section className={cn(s.dept, s.es)}>
        <div className={s.text}>
          <div>
            <h2>
              環境システム学科<span>自然環境の、美しい仕組みを知る。</span>
            </h2>
            <p>
              たとえば、太古の地殻変動から今日の天気、近所の川に棲む魚の将来まで、空間的にも時間的にも幅広く地球のことを何でも知るため、環境科学を体系的に学ぶことができます。フィールドワークで観察・試料採取を行い、測器を用いて観測・計測し、室内で分析・解析。それらの情報を有機的に結びつけるトレーニングを重ねることで、地球環境・自然環境とは生物、大地、気象、水のそれぞれが役割をもった美しいシステムであることに気づくのです。
            </p>
          </div>

          <div className={s.fig}>
            <p>
              <EsFig />
            </p>
          </div>

          <div>
            <h3>
              <span>生物・地球コース</span>
              <DeptIcon1 className={cn(s.icon, s.icon1)} />
            </h3>
            <p>
              陸生動物・水生動物・植物の生態、外来種・絶滅危惧種と生物多様性、地形・地層の成り立ち、岩石・鉱物と地殻変動、地震・火山・土砂災害、それらの環境情報の解析方法など、主に固体地球と生物（地圏・生物圏）および環境情報に関する知識と技術を修得するコースです。生物分類技能検定や自然再生士のような資格取得に役立つ授業もあります。
            </p>
          </div>

          <div>
            <h3>
              <span>気象・水文コース</span>
              <DeptIcon2 className={cn(s.icon, s.icon2)} />
            </h3>
            <p>
              身近な天気、地球全体の気候システム、台風・竜巻・雷などの気象災害、気象条件と人間の健康、河川・湖沼・地下水・温泉などの水循環と水利用、水質汚染や水害、それらの環境情報の解析方法など、主に地球上の流体（気圏・水圏）および環境情報に関する知識と技術を修得するコースです。気象予報士や環境計量士のような資格取得に役立つ授業もあります。
            </p>
          </div>
          <BorderButton
            label="環境システム学科についてもっと知る"
            href="/environment-systems/"
            // disabled
          />
        </div>
        <Slider items={es} />
      </section>

      <section className={cn(s.dept, s.geo)}>
        <div className={s.text}>
          <div>
            <h2>
              地理学科<span>人を見つめ、地域を見つめ、社会を見つめる。</span>
            </h2>
            <p>
              地理学の目標は、自然環境の負荷を軽減しながら限りある資源を活用し、貧困のない安全で公正な社会を構築することです。近年の多様な災害の頻発により、社会の構築に携わる誰もが適切な教育を受け、課題解決に取り組むことが急務となっています。地理学科では「人文地理学」「地図・GIS・測量」「自然地理学」の三つの柱から、地球上で起きていることを多角的に理解し、問題解決に向けて主体的に貢献できる人材を育成します。
            </p>
          </div>

          <div className={s.fig}>
            <p>
              <GeoFig />
            </p>
          </div>

          <div>
            <h3>
              <span>人文地理学</span>
              <DeptIcon3 className={cn(s.icon, s.icon3)} />
            </h3>
            <p>
              人口や経済、都市構造、交通、観光等の要素をとおして、人が与えられた自然条件にいかに適応し、また一方でその恩恵を受けながら、どのように活動しているかに注目します。人間活動の効率性を追求しつつ、社会の安定と平和のあり方、現代社会が抱える諸問題を考えることもこの学問の使命です。持続可能な社会を構築し、人びとが安心して生活できる地域づくりを実現するため、質の高い学びによる課題解決を通じ、SDGsの推進にも貢献していきます。
            </p>
          </div>

          <div>
            <h3>
              <span>自然地理学</span>
              <DeptIcon4 className={cn(s.icon, s.icon4)} />
            </h3>
            <p>
              地形学、気候学、水文学を軸に、地球上のあらゆる自然現象を扱い、それらの相互作用について研究します。「降水量の変動」ひとつをとっても、自然災害や地下水の変化に加え、農業や生活様式など人間活動への影響といった多角的な視点や、直接人が感じることができる数年という短い期間だけでなく100年〜10万年という長期間のなかで気候変動を考えることが重要です。一方で、気候変動にともなう植生の変化が降水量へどのように影響するか、といった反対方向の作用についても考えます。幅広い視野から、自然災害，気候変動，陸域生態系や森林，水と衛生に関する問題などを中心に、持続可能な環境づくりのため、多岐にわたるゴールにアプローチしていける分野です。
            </p>
          </div>

          <div>
            <h3>
              <span>地図・GIS・測量</span>
              <DeptIcon5 className={cn(s.icon, s.icon5)} />
            </h3>
            <p>
              地図のしくみや地図表現の基本、地表に存在するものの位置や形を正確に計測する測量技法、自らが現地調査で取得したデータを地理情報システム(GIS)に取り込み地図化する方法を実践的に学んでいきます。事象を空間的に整理し、計測・表現することは、問題の分析や共有化に欠かせない技術であり、自然環境や人間活動のさまざまな問題点を顕在化させます。このような技能によって、人びとの生活や福祉の状態を正しく把握することは、平和な社会の構築につながります。また、地図や測量技術をベースにした地理的思考は、グローバル・パートナーシップを大きく活性化させます。
            </p>
          </div>

          <BorderButton
            label="についてもっと知る"
            href="/geography/"
            // disabled
          />
        </div>
        <Slider items={geo} bgWhite={true} />
      </section>

      <PageFooter isTop={true} />
      <SiteFooter />
    </>
  )
}

export default Page

// export const query = graphql`
//   {
//     site {
//       buildTime(formatString: "YYYY-MM-DD hh:mm a z")
//     }
//   }
// `
